export function toBase64(file) {

    return new Promise((resolve, reject) => {
      
        const reader = new FileReader();
        
        reader.readAsDataURL(file); // Convert the file to base64 format
    
        // Remove the base64 prefix and resolve with the base64 string
        reader.onload = () => { resolve(reader.result.split(',')[1]); };
    
        reader.onerror = (error) => { reject(error); };

    });

  }